import { useContext } from 'react';

import { CurrentUserContext } from '../Contexts/CurrentUserContext';

const useCurrentUser = () => {
  return useContext(CurrentUserContext);
};

export default useCurrentUser;
